<template>
    <form ref="vform" class="form" @submit.prevent="submit">

        <fieldscontact :items="form" @returnStatusToParent="statusParentHandler"></fieldscontact>

        <div class="row">
            <div class="col wide">
                <div class="info-text" v-if="$store.state.submitStatus === 'ERROR' || $store.state.submitStatus === 'OK' || $store.state.submitStatus === 'PENDING'">
                    <div class="success" v-if="$store.state.submitStatus === 'OK'">
                        <div class="icon-cross close" @click="$store.state.submitStatus = null"></div>
                        Thanks for your submission!
                    </div>
                    <div class="error-wrap" v-if="$store.state.submitStatus === 'ERROR'">
                        <div class="icon-cross close" @click="$store.state.submitStatus = null"></div>
                        Some required fields are missing. Please fix them.
                    </div>
                    <div class="typo__p" v-if="$store.state.submitStatus === 'PENDING'">Sending...</div>
                </div>
            </div>
        </div>

        <vue-recaptcha :sitekey="recapthcakey"
                       data-badge="inline"
                       ref="recaptcha"
                       size="invisible"
                       @verify="onVerify"></vue-recaptcha>
    </form>
</template>

<script>
    import fieldscontact from "./fieldscontact.vue";
    import Vue from 'vue'
    import { mapState } from 'vuex'
    import Vuelidate from 'vuelidate'
    import { required, email } from 'vuelidate/lib/validators'
    import VueRecaptcha from 'vue-recaptcha';
    import VueScrollTo from 'vue-scrollto'
    import VueMask from 'v-mask'

    Vue.use(VueMask);
    Vue.use(Vuelidate);
    Vue.use(VueScrollTo);

    export default {
        name: 'Contact',
        components: {
            'vue-recaptcha': VueRecaptcha,
            fieldscontact
        },
        props: [
            'formtype',
            'recapthcakey',
            'form',
            'actionprops',
            'form_id'
        ],
        data() {
            return {
                captcha: '',
                childHasError: true
            }
        },
        validations() {

        },
        methods: {
            submit() {
                this.childHasError = true
                this.$eventPool.$emit("touchChildForm")

                this.$nextTick(() => {
                    if (this.childHasError) {
                        this.$refs.recaptcha.execute();
                    } else {
                        this.$store.state.submitStatus = 'ERROR';
                        setTimeout(() => {
                            VueScrollTo.scrollTo('.error', 300);
                        }, 200);
                    }
                })
            },
            onVerify: function (response) {
                this.$store.state.submitStatus = 'PENDING';

                let formData = new FormData();
                formData.append('g-recaptcha-response', response);
                formData.append('form_type', 'contact');
                formData.append('form_id', this.form_id);

                const currentForm = this.$store.state.currentForm
                Object.keys(currentForm).forEach((item) => {
                    if (typeof currentForm[item] === 'object') {
                        formData.append(item, JSON.stringify(currentForm[item]))
                    } else {
                        formData.append(item, currentForm[item])
                    }
                })

                axios.post(this.actionprops, formData)
                    .then(response => {
                        console.log('message', response);

                        if (response.data.result === 'ok') {
                            this.$store.state.submitStatus = 'OK';

                            formData = new FormData();
                            this.childHasError = true;
                            this.$store.state.currentForm = {};
                            this.$refs.vform.reset();
                            this.$eventPool.$emit("resetChildForm");

                        }

                        if (response.data.result === 'error') {
                            this.$store.state.submitStatus = 'ERROR';
                        }

                        this.$refs.recaptcha.reset();
                    })
                    .catch(error => {
                        console.log(error)
                        this.$refs.recaptcha.reset();
                    });
            },
            status(validation) {
                return {
                    error: validation.$error,
                    dirty: validation.$dirty
                }
            },
            statusParentHandler(isValid) {
                this.childHasError = this.childHasError && isValid
            },
        }
    }
</script>

<style scoped lang="scss">
    .form .info-text {
        margin-top: 0;
    }

</style>
